import { gql } from '@apollo/client';

import { Server } from '../apollo/types';
import { useAppDependenciesContext } from '../state';

type MomentumPilotFeatureAccess = {
  key: string;
  enabled: boolean;
  disabledReasons: {
    disabledByType: string;
  }[];
};

type MomentumPilotAccessForProviderQuery = {
  momentumPilotFeatureForProvider: MomentumPilotFeatureAccess;
};

type MomentumPilotAccessForProviderQueryVariables = {
  providerShortId: string;
  key: string;
};

export const MOMENTUM_PILOT_ACCESS_QUERY = gql`
  query MomentumPilotFeatureForProvider($providerShortId: String!, $key: String!) {
    momentumPilotFeatureForProvider(providerShortId: $providerShortId, key: $key) {
      key
      enabled
      disabledReasons {
        disabledByType
      }
    }
  }
`;

export function useMomentumPilotAccess(providerShortId: string, key: string) {
  const { useQuery } = useAppDependenciesContext();

  const { data, loading, error } = useQuery<
    MomentumPilotAccessForProviderQuery,
    MomentumPilotAccessForProviderQueryVariables
  >(MOMENTUM_PILOT_ACCESS_QUERY, {
    variables: {
      providerShortId,
      key,
    },
    skip: !providerShortId || !key,
    context: {
      server: Server.MONOLITH,
    },
  });

  return {
    pilotAccess: data?.momentumPilotFeatureForProvider,
    loading,
    error,
  };
}
